module.exports = __webpack_public_path__ + "img/jetbrains-mono-light.852ec89a.png";